import { Button } from '@shared/components/common/Button';
import { HomeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

interface NotFoundPageProps {
    homeHref?: string
}

export default function NotFoundPage({ homeHref = '/' }: NotFoundPageProps) {
    return (
        <div className='h-full flex flex-col items-center justify-center px-4 py-12'>
            <div className='relative mb-6'>

                <div className='flex items-center justify-center'>
                    <svg
                        className='size-20 md:size-28 text-primary'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth={1.5}
                            d='M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                        />
                    </svg>
                </div>

                <span className='block text-8xl leading-tight md:text-9xl font-extrabold tracking-wider text-primary select-none'>
                    404
                </span>
            </div>

            {/* Message */}
            <h1 className='text-2xl md:text-3xl font-bold mb-3 text-center'>
                ページが見つかりませんでした
            </h1>
            <p className='text-base md:text-lg text-text-secondary mb-8 text-center max-w-lg'>
                お探しのページは存在しないか、移動した可能性があります。
            </p>

            {/* Back to Home Button */}
            <Link to={homeHref}>
                <Button
                    variant='default'
                    className='gap-2 rounded-lg h-12 md:h-14 px-8 text-base md:text-lg hover:bg-primary-hover transition-colors'
                >
                    <HomeIcon />
                    ホームに戻る
                </Button>
            </Link>
        </div>
    );
}
